import { render, staticRenderFns } from "./CommonRatingStars.vue?vue&type=template&id=14b0b904"
import script from "./CommonRatingStars.vue?vue&type=script&lang=js"
export * from "./CommonRatingStars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports